// Libraries
import React from 'react';

// Material-UI
import Box from '@material-ui/core/Box';

export default function IllustrationMine() {
  return (
    <Box marginTop={5}>
      <img
        style={{ marginBottom: '-5px' }}
        width="100%"
        src="/images/digital-mine.gif"
        alt="IntelliSense.io Digital Mine"
      />
    </Box>
  );
}
